import React, { useEffect, useState } from "react";
import Navbar from "../component/navbar";
import ContactUs from "../component/contactus";
import "../component/mainSign.css";
import { RequestDemoApi } from "../apis";
import { Alert } from "@mui/material";

const SignUp = () => {
  const [fullName, setFullName] = useState("");
  const [companyName, setCompanyName] = useState("");
  const [phoneNo, setPhoneNo] = useState("");
  const [email, setEmail] = useState("");
  const [infoError, setInfoError] = useState(false);
  const [address, setAddress] = useState("");
  const [showAlert, setShowAlert] = useState(false);
  const [alertType, setAlertType] = useState("");
  const [message, setMessage] = useState("");

  const RequestRouter = RequestDemoApi();

  const handleSignUp = async () => {
    try {
      if (!fullName || !companyName || !phoneNo || !email || !address) {
        setInfoError(true);
      }

      const res = await RequestRouter.create({
        name: fullName,
        email: email,
        phone: phoneNo,
        address: address,
        companyName: companyName,
      });

      if (res.status !== 200 && res.status !== 201) {
        const msg =
          res?.error?.response?.data?.data?.message ||
          "An unknown error occured";
        setMessage(msg);
        setAlertType("error");
        setShowAlert(true);
      } else {
        const msg = res?.data?.msg;
        setMessage(msg);
        setShowAlert(true);
        setAlertType("success");
        setFullName("");
        setCompanyName("");
        setPhoneNo("");
        setEmail("");
        setAddress("");
      }
    } catch (error) {
      console.log("request create error", error);
    }
  };

  useEffect(() => {
    if (showAlert) {
      const timeoutId = setTimeout(() => {
        setShowAlert(false);
      }, 50000);
      return () => {
        clearTimeout(timeoutId);
      };
    }
    // eslint-disable-next-line
  }, [showAlert]);

  return (
    <>
      <Navbar />
      <div className="request-demo-backgroud">
        <img
          src="./images/PVX/Group1.svg"
          alt="group"
          className="group-image"
          style={{ left: "-147px", top: "100px" }}
        />
        <img
          src="./images/PVX/Group2.svg"
          alt="group"
          className="group-image"
          style={{ left: "-60px", top: "400px" }}
        />
        <img
          src="./images/PVX/Group3.svg"
          alt="group"
          className="group-image"
          style={{ left: "-100px", top: "800px" }}
        />
        <form className="request-form">
          <div className="title">Request Sign Up</div>
          <div className="input-pair">
            <div className="input-title">Full Name *</div>
            <input
              className="input"
              type="text"
              placeholder="Full Name"
              value={fullName}
              onChange={(e) => setFullName(e.target.value)}
            ></input>
            {!fullName && infoError && <span>This field is mandatory</span>}
          </div>
          <div className="input-pair">
            <div className="input-title">Company Name *</div>
            <input
              className="input"
              type="text"
              placeholder="Company Name"
              value={companyName}
              onChange={(e) => setCompanyName(e.target.value)}
            ></input>
            {!companyName && infoError && <span>This field is mandatory</span>}
          </div>
          <div className="input-pair">
            <div className="input-title">Phone No *</div>
            <input
              className="input"
              type="text"
              placeholder="Enter your phone number"
              value={phoneNo}
              maxLength="11"
              onChange={(e) => setPhoneNo(e.target.value)}
              onKeyPress={(e) => {
                if (e.which < 48 || e.which > 57) {
                  e.preventDefault();
                }
              }}
            />
            {!phoneNo && infoError && <span>This field is mandatory</span>}
          </div>
          <div className="input-pair">
            <div className="input-title">Address *</div>
            <input
              className="input"
              type="text"
              placeholder="enter your comapnay address"
              value={address}
              onChange={(e) => setAddress(e.target.value)}
            ></input>
            {!address && infoError && <span>This field is mandatory</span>}
          </div>
          <div className="input-pair">
            <div className="input-title">Email ID *</div>
            <input
              className="input"
              type="email"
              placeholder="Enter your email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            ></input>
            {!email && infoError && <span>This field is mandatory</span>}
          </div>
          <div className="logIn" onClick={handleSignUp}>
            Request Sign Up
          </div>
          <p className="info" style={{ fontSize: "14px", minWidth: "320px" }}>
            <strong>
              Your request has been received. Within 24 hours, it will be
              approved, and a confirmation email will be sent to your provided
              email address, including your sign-in credentials.
            </strong>
            <br></br> Privacy Policy | Terms of Use | Cookies Policy
          </p>
        </form>
      </div>
      <ContactUs />
      {showAlert && (
        <Alert
          severity={alertType}
          sx={{
            position: "absolute",
            top: "100px",
            right: "20px",
            width: "350px",
            fontSize: "14px",
            animation: "pulse 1.5s infinite", // 👈 continuous zoom
            "@keyframes pulse": {
              "0%": { transform: "scale(1)" },
              "50%": { transform: "scale(1.05)" },
              "100%": { transform: "scale(1)" },
            },
          }}
        >
          {alertType === "success" ? (
            <strong>
              Request Received <br></br>Your sign-in credentials will be
              forwarded to your email within 24 hours.
            </strong>
          ) : (
            message
          )}
        </Alert>
      )}
    </>
  );
};

export default SignUp;
